/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Status_ReturnedInputs */

const vi_dashboard_status_returned = /** @type {(inputs: Dashboard_Status_ReturnedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoàn trả`)
};

/**

* @param {Dashboard_Status_ReturnedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_status_returned = /** @type {((inputs?: Dashboard_Status_ReturnedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Status_ReturnedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_status_returned(inputs)
});